import { CommandItem } from "@/components/ui/command";
import { RawCommandItemContent } from "./RawCommandItemContent";

export interface MagicCommandItemProps {
	title: React.ReactNode;
	description: React.ReactNode;
	colors: string[] | null;
	extra?: React.ReactNode;
	image?: { src?: string; alt: string };
	onSelect: () => void;
	selected?: boolean;
	commandValue?: string;
}

export const MagicCommandItem: React.FC<MagicCommandItemProps> = ({
	title,
	description,
	colors,
	extra,
	image,
	onSelect,
	selected,
	commandValue,
}) => {
	return (
		<CommandItem
			value={commandValue}
			onSelect={onSelect}
			onClick={onSelect}
			className="w-full flex gap-2 items-start *:h-full cursor-pointer"
		>
			<RawCommandItemContent
				title={title}
				description={description}
				colors={colors}
				extra={extra}
				image={image}
				selected={selected}
			/>
		</CommandItem>
	);
};
